import React from "react";

export default function Ham() {
    return (
        <svg id="ae52f0ca-5350-473e-9e98-850d6e381ba6" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M24,6H0V2H24Zm0,4H0v4H24Zm0,8H0v4H24Z" fill="#efedec"/><rect width="24" height="2" opacity="0"/><rect y="22" width="24" height="2" opacity="0"/></svg>
    );
}